import script from "./WaitingListTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./WaitingListTickets.vue?vue&type=script&setup=true&lang=js"

import "./WaitingListTickets.vue?vue&type=style&index=0&id=1be2f157&lang=scss&setup=true"

const __exports__ = script;

export default __exports__